import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import PageHeading from '../../components/PageHeading/PageHeading';
import { useNavigate, useParams } from 'react-router-dom';
import { colors } from '../../config/constants';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import Dailog from '../../components/Dailog/Dailog';
import { errorMessageAutoCapitalize } from '../../config/helpers';
import { errorMessage } from '../../config/errorsMsg';
import { successMessage } from '../../config/keyword';

type ResultProps = {
  host: string;
  id: string;
  sequenceNumber: number;
  siteUrl: string;
};

const WebsiteDetailsSupAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [site, setSite] = useState<ResultProps>({
    siteUrl: '',
    host: '',
    sequenceNumber: 0,
    id: '',
  });
  const { siteUrl } = site;
  const [state, setState] = useState<any>([]);
  const [siteEdit, setSiteEdit] = useState<boolean>(false);
  const [isDeletePopup, setIsDeletePopup] = useState<boolean>(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const breadcrumb = [
    { path: '/websitesSuper', name: 'Website' },
    { path: `/websiteDetails/${id}`, name: 'Website Details' },
  ];

  useEffect(() => {
    dispatch(update_breadcrumb(breadcrumb));
    getWebsiteById();
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      updateSite();
    }
  }, [formError]);

  const gotResponse = (data: ResultProps) => {
    setSite(data);
    setState(data);
    dispatch(updateIsLoading(false));
  };

  const siteHandleEditUpdate = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const websiteEditCancel = () => {
    setSiteEdit(false);
    setSite(state);
    setFormError({});
    setIsSubmit(false);
  };

  const validation = () => {
    const error: any = {};
    if (!siteUrl) {
      error.siteUrl = errorMessage.emptyWebsite;
    }
    return error;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSite({ ...site, [event.target.name]: event.target.value });
    if (event.target.name === 'siteUrl') {
      const format = /^\S*$/;
      format.test(event.target.value) &&
        setSite({
          ...site,
          [event.target.name]: event.target.value,
        });
    } else {
      setSite({
        ...site,
        [event.target.name]: event.target.value,
      });
    }
    if (event.target.value !== '') {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required`,
      });
    }
  };

  const getWebsiteById = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/site/${id}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const deleteSite = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .delete(`/site/${id}`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.SITE_DELETE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsDeletePopup(false);
          setTimeout(() => {
            navigate(`/websitesSuper`);
          }, 1000);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const updateSite = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .put(`/site/${id}`, site)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.SITE_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
        }
        getWebsiteById();
        setSiteEdit(false);
        dispatch(updateIsLoading(false));
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || err.response.data.errors.Code[0],
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const siteHandleEdit = () => {
    setSiteEdit(!siteEdit);
  };

  return (
    <>
      <div className="px-2 pt-1">
        <PageHeading label="Website Details" />
        <div
          className={`justify-between ${colors.primaryText} bg-white rounded-sm p-5`}
        >
          <div className="sm:flex text-md mb-2">
            <div className="sm:w-1/3 ">Site Url</div>
            {siteEdit ? (
              <div className="sm:w-2/4">
                <Input
                  type={'text'}
                  placeholder={'Enter site Url'}
                  value={site.siteUrl}
                  name={'siteUrl'}
                  onChange={handleChange}
                  error={formError?.siteUrl}
                />
              </div>
            ) : (
              <div className=" text-black flex sm:w-2/4">
                <div>{site.siteUrl}</div>
              </div>
            )}
          </div>

          <div className="sm:flex text-md mb-2">
            <div className="sm:w-1/3 ">Host</div>
            <div className=" text-black flex sm:w-2/4">
              <div>{site.host}</div>
            </div>
          </div>
          <div className="sm:flex text-md mb-2">
            <div className="sm:w-1/3 ">Site Number</div>
            <div className=" text-black flex sm:w-2/4">
              <div>{site.sequenceNumber}</div>
            </div>
          </div>
          <div className="flex items-center justify-end">
            <div className="flex justify-center md:justify-end pt-5 pr-2 md:pt-0">
              {siteEdit ? (
                <div className="flex mx-auto md:mx-0 justify-end w-[250px]">
                  <div className="mr-4">
                    <Button
                      label="Update"
                      buttonType="primary"
                      type="button"
                      onClick={() => siteHandleEditUpdate()}
                      disabled={state.siteUrl === siteUrl}
                    />
                  </div>
                  <Button
                    label="Cancel"
                    buttonType="danger"
                    type="button"
                    onClick={() => websiteEditCancel()}
                  />
                </div>
              ) : (
                <div className="flex justify-center md:justify-end">
                  <Button
                    label="Edit"
                    buttonType="primary"
                    type="button"
                    onClick={() => siteHandleEdit()}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center pt-5">
        <Button
          label="Delete Site"
          buttonType="danger"
          type="button"
          onClick={() => setIsDeletePopup(true)}
        />
        <Dailog
          isDeletePopup={isDeletePopup}
          setIsPopupOpen={setIsDeletePopup}
          title={'Website'}
          onConfirm={() => {
            deleteSite();
          }}
        />
      </div>
    </>
  );
};
export default WebsiteDetailsSupAdmin;
